var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { useEffect } from 'react';
import triggerAnalyticsEvent from 'syf-js-utilities/helpers/triggerAnalyticsEvent';
import { ModalOptions } from '../../../../typings/common';
import { StyledText, StyledTitle } from '../../../../styles/text';
import InProgressIllustration from '../../error/in-progress-illustration';
import SubmissionIllustration from '../../error/submission-illustration';
import ErrorIllustration from '../../../illustrations/network-error';
import { IllustrationContainer, RequestInProgressWrapper, StyledDurationText } from './subcomponents';
import { AnalyticsValues, TriggerAnalyticsKeys } from '../../../../const/analytics';
var RefundRequestStatus = function (_a) {
    var currentModal = _a.currentModal;
    var t = useTranslation().t;
    useEffect(function () {
        var _a;
        if (currentModal === ModalOptions.inProgress) {
            triggerAnalyticsEvent((_a = {},
                _a[TriggerAnalyticsKeys.pageKind] = AnalyticsValues.cbr,
                _a[TriggerAnalyticsKeys.pageFunction] = AnalyticsValues.manageCreditBalance,
                _a[TriggerAnalyticsKeys.pageName] = AnalyticsValues.refundInProgress,
                _a[TriggerAnalyticsKeys.message] = AnalyticsValues.refundRequestInProgress,
                _a));
        }
    }, [currentModal]);
    var errorTitle = t('error.networkHeading');
    var inProgressTitle = t('text.requestInProgress');
    var successTitle = t('text.requestSuccessfullySubmitted');
    var errorSubtitle = t('error.networkMessage');
    var subtitle = t('subtext.requestRefundCheck').split('{{duration}}');
    var subtitleFirstPart = subtitle[0];
    return (_jsx(Inset, __assign({ top: "large", vertical: "xxlarge" }, { children: _jsxs(RequestInProgressWrapper, __assign({ direction: "column", alignItems: "center" }, { children: [_jsxs(IllustrationContainer, { children: [currentModal === ModalOptions.success && _jsx(SubmissionIllustration, {}), currentModal === ModalOptions.inProgress && (_jsx(InProgressIllustration, {})), currentModal === ModalOptions.refundError && _jsx(ErrorIllustration, {})] }), _jsx(Stack, { size: "large" }), _jsxs(StyledTitle, __assign({ size: "medium", weight: "bold", align: "center" }, { children: [currentModal === ModalOptions.success && successTitle, currentModal === ModalOptions.inProgress && inProgressTitle, currentModal === ModalOptions.refundError && errorTitle] })), _jsx(Stack, { size: "small" }), _jsx(StyledText, __assign({ align: "center" }, { children: currentModal === ModalOptions.refundError ? (errorSubtitle) : (_jsxs(_Fragment, { children: [subtitleFirstPart, _jsxs(StyledDurationText, { children: [" ", t('subtext.duration'), "."] })] })) }))] })) })));
};
export default RefundRequestStatus;
